import { useState } from "react";
import { Box, Typography } from "@mui/material";
import AssignTaskForm from "./AssignTaskForm";
import ManualTaskAssignmentReport from "./ManualTaskAssignmentReport";

export default function ClioMatterInteraction() {
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" className="title" fontWeight={600}>
          Clio Task Assignments
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Assign tasks in Clio and review recent manual assignments.
        </Typography>
      </Box>

      <AssignTaskForm onAssigned={() => setRefreshKey((key) => key + 1)} />
      <ManualTaskAssignmentReport refreshKey={refreshKey} />
    </Box>
  );
}
